import React from "react";
import PropTypes from "prop-types";
import FormFieldTwoColumns from "./Layouts/FormFieldTwoColumns";
import FormDatetime from "./FormDatetime";

function FormDatetimeTC(props) {
  return (
    <FormFieldTwoColumns {...props}>
      <FormDatetime name={props.name} />
    </FormFieldTwoColumns>
  );
}

FormDatetimeTC.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props

  textFieldType: PropTypes.string,
  timeFormat: PropTypes.string,
  dateFormat: PropTypes.string,
  outputFormat: PropTypes.string,
};

FormDatetimeTC.defaultProps = {
  textFieldType: "text",
  timeFormat: "HH:mm",
  dateFormat: "dd-MM-yyyy",
  outputFormat: "yyyy-MM-dd HH:mm:ss",
};

export default FormDatetimeTC;
